import React from 'react';
import { observer } from 'mobx-react';

import {BaseViewStore} from "core/stores";
import {ModalParams} from 'core/models';
import { HeaderTemplate } from 'themes/components';
import { useStores, useViewStore } from 'core/stores/StoreContext';

const Header = observer((props) => {
    const rootStore = useStores();
    const headerViewStore = useViewStore(() => new HeaderViewStore(rootStore));

    return (
        <HeaderTemplate
            {...props}
            rootStore={rootStore}
            routerStore={rootStore.routerStore}
            appStore={rootStore.appStore}
            viewStore={rootStore.viewStore}
            menuStore={rootStore.menuStore}
            breadcrumbs={rootStore.viewStore.breadcrumbs}
            headerViewStore={headerViewStore}
        />
    );
});

export default Header;

class HeaderViewStore extends BaseViewStore {
    constructor(rootStore) {
        super(rootStore);
        this.rootStore = rootStore;

        this.applicationSelectorModal = new ModalParams({});
    }
}
